import { useCallback, useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { API } from "../App";
import { authFetch } from "../lib/auth";

/** One line pinned to the top of the admin screen while a face run is going,
 *  so the state is in view wherever you have scrolled. Asks the server on its
 *  own, so it appears after a reload or for a run started on another device. */
const FaceRunStrip = () => {
  const [batch, setBatch] = useState(null);

  const check = useCallback(async () => {
    const res = await authFetch(`${API}/admin/faces/batches/active`);
    if (res.ok) setBatch((await res.json()).batch);
  }, []);

  useEffect(() => {
    check();
    const t = setInterval(check, 5000);
    return () => clearInterval(t);
  }, [check]);

  if (!batch?.running) return null;

  return (
    <button
      onClick={() => {
        const panel = document.getElementById("face-generation-panel");
        panel?.scrollIntoView({ behavior: "smooth", block: "center" });
      }}
      className="sticky top-0 z-40 w-full bg-primary/15 border-b border-primary text-left"
      data-testid="face-run-strip"
    >
      <div className="max-w-4xl mx-auto px-6 py-2 flex items-center gap-2">
        <Loader2 className="w-4 h-4 text-primary animate-spin shrink-0" />
        <span className="text-sm" data-testid="face-run-strip-text">
          {batch.headline}
        </span>
      </div>
      <div className="h-0.5 bg-primary/20">
        <div
          className="h-full bg-primary transition-all duration-500"
          style={{ width: `${batch.percent}%` }}
        />
      </div>
    </button>
  );
};

export default FaceRunStrip;
